<div class="mb-4 flex items-center">
  <div class="mr-2 text-sm">Vendor Contract</div>
  <aux-vendor-dropdown
    [showAllOption]="true"
    [vendors]="(organizationQuery.allVendors$ | async)!"
    [formControl]="selectedVendor"
    (onChange)="onOrganizationSelected($event)"
  />
</div>

<div class="mb-8 grid grid-cols-3 gap-7.5">
  <aux-card-select [config]="(filter$ | async)!" [loading]="(loading$ | async) === true" />

  <div class="grid grid-cols-12 rounded border p-4">
    <div class="col-span-7 flex flex-col justify-center border-r">
      <div class="font-bold">
        Pre-paid Balance in
        <br />
        Escrow
      </div>
    </div>
    @if ((loading$ | async) === true) {
      <div class="col-span-5 flex items-center justify-center">
        <div class="spinner"></div>
      </div>
    }
    @if ((loading$ | async) === false) {
      @if (middle$ | async; as middle) {
        <div
          class="col-span-5 flex items-center justify-center pl-5 text-lg font-bold tabular-nums"
        >
          <div>
            <div>{{ middle.amount | money }}</div>
          </div>
        </div>
      }
    }
  </div>

  <div class="grid grid-cols-12 rounded border p-4">
    <div class="col-span-7 flex flex-col justify-center border-r">
      <div class="font-bold">Next Milestone</div>
    </div>
    @if ((loading$ | async) === true) {
      <div class="col-span-5 flex items-center justify-center">
        <div class="spinner"></div>
      </div>
    }
    @if ((loading$ | async) === false) {
      @if (right$ | async; as right) {
        <div
          class="col-span-5 flex items-center justify-center pl-5 text-lg font-bold tabular-nums"
        >
          <div>
            <div>{{ right.target_date | date }}</div>
            <div>{{ right.amount | money }}</div>
          </div>
        </div>
      }
    }
  </div>
</div>

<div class="mb-8 flex justify-between">
  <div class="font-bold">Payments vs. Work Performed</div>

  <div class="flex justify-end space-x-4 text-xxs">
    @for (legend of legends; track legend) {
      <div class="flex items-center justify-between space-x-2">
        <div
          class="h-3.5 w-6 rounded"
          [style]="{
            backgroundColor: legend.color,
          }"
        ></div>
        <div>{{ legend.header }}</div>
      </div>
    }
  </div>
</div>

@if ((loading$ | async) === true) {
  <!--  table$-->
  <div class="spinner m-auto mt-40 h-32 w-32 border-8"></div>
}
@if ((loading$ | async) !== true) {
  @if (chart$ | async; as chart) {
    <div style="height: 250px" class="ml-32">
      <canvas
        baseChart
        [datasets]="chart.data.datasets"
        [labels]="chart.data.labels"
        [options]="chart.options"
        [legend]="false"
        [type]="chart.type"
      ></canvas>
    </div>
  }
  <aux-payments-history [title]="'Cash Requirements'" [historyKey]="'payment'" />
  <aux-payments-history [title]="'Work Performed'" [historyKey]="'wp'" />
  <aux-payments-history [title]="'Variance'" [historyKey]="'delta'" />

  <div class="my-8 font-bold">Work Performed, by Milestone</div>
  <table class="w-full">
    <thead>
      <th class="text-left text-xs font-bold text-aux-black">Milestone</th>
      <th class="text-xs font-bold text-aux-black">Milestone Payment ($)</th>
      <th class="text-xs font-bold text-aux-black">Target Date</th>
      <th class="text-xs font-bold text-aux-black">Vendor Contract</th>
    </thead>
    <tbody>
      @for (data of table$ | async; track data) {
        <tr>
          <td class="border-b border-aux-gray-light pb-4 pt-4 text-left text-xs">
            {{ data.name }}
          </td>
          <td class="border-b border-aux-gray-light pb-4 pt-4 text-center text-xs tabular-nums">
            {{ data.amount | money }}
          </td>
          <td class="border-b border-aux-gray-light pb-4 pt-4 text-center text-xs tabular-nums">
            {{ data.date | date }}
          </td>
          <td class="border-b border-aux-gray-light pb-4 pt-4 text-center text-xs tabular-nums">
            {{ data.organization_name }}
          </td>
        </tr>
      }
    </tbody>
  </table>
  <div class="mb-16"></div>
}
